import Cookies from 'js-cookie';
import whenDomReady from 'when-dom-ready';
function initialise() {
    const ACTIVE = 'is-active';
    const COOKIE_NAME = 'salaryfinance.cookieacceptance';
    const cookieBar = document.querySelector('.js-cookie-bar');
    const cookieBarAccept = document.querySelector('.js-cookie-accept');
    const cookieValue = Cookies.get(COOKIE_NAME);
    if (!cookieBar || !cookieBarAccept || cookieValue === 'true') {
        return;
    }
    cookieBar.classList.add(ACTIVE);
    cookieBarAccept.addEventListener('click', () => {
        Cookies.set(COOKIE_NAME, 'true', { expires: 365 });
        cookieBar.classList.remove(ACTIVE);
    });
}
whenDomReady().then(initialise);
